
import { Text, Paper, Image, Button, Modal, Grid, Group, Space, Tooltip, Alert, createStyles} from '@mantine/core';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import intl from "react-intl-universal";
import { IDAustriashowAdress } from './IDAustriashowAdress';
import { AlertTriangle, UserCheck } from 'tabler-icons-react';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = createStyles((theme) => ({
  bgred: {
    backgroundColor: `rgb(250, 82, 82, 0.1);`,
  },
}));


const IdentShowIDAustriaData = (props:any) => {  
  const dispatch = useDispatch()
  const { classes } = useStyles();
  const drnId = useSelector((state: any) => state.user.meetinginfo.drnId)
  const isconfirmuser = useSelector((state: any) => state.user.meetinguser)
  const [opened, setOpened] = useState(false);
  const [opened1, setOpened1] = useState(false);
  const [openconfirm, setOpenConfirm] = useState(false);
  const [removeconfirm, setOpenRemoveConfirm] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
 
    
  //console.log(props)


    const idaData = props.idaustriadata[0];

    //console.log(idaData.participantModel.idAustriaData.isIdentified)

    const authId = idaData.authId.toString();
    const family_name = idaData.family_name.replace(/^"|"$/g, '');
    const given_name  = idaData.given_name.replace(/^"|"$/g, '');
    const birthdate  = idaData.birthdate.replace(/^"|"$/g, '');
    const portrait =  idaData.portrait;
    const auth_time =  idaData.auth_time;
    const exp =  idaData.exp;
    const signature_usual_mark = idaData.signature_usual_mark
    const portrait_capture_date = idaData.portrait_capture_date
    const urn_issuing_nation = idaData.urn_issuing_nation
   

    const urn_attributes_mainAddress = idaData.urn_attributes_mainAddress
  

    let modalpichead = intl.get('IDA_MODAL_PIC_HEAD') + " " + portrait_capture_date

    useEffect(() => {
      let interval: NodeJS.Timeout
      const checkExpiration = () => {
        const now = dayjs();
        const expirationDate = dayjs(exp);
        setIsExpired(now.isAfter(expirationDate));
   
        if (now.isAfter(expirationDate)) {
          clearInterval(interval);
        }
      };
         
      checkExpiration();
      interval = setInterval(checkExpiration, 30 * 1000);

      return () => clearInterval(interval);
    }, [exp]);



    const isconfirmuserdata = isconfirmuser.filter((obj: { id: any; }) => {
      return obj.id === props.MeetingParticipantId
      });

    let showconfirmbutton = true  
    if (isconfirmuserdata[0].idAustriaData.isIdentified !== undefined) {
      if (isconfirmuserdata[0].idAustriaData.isIdentified){
        showconfirmbutton = false
      }
    }


    const handleOpen = () => {
      setOpened(true);
    };
  
    const handleClose = () => {
      setOpened(false);
    };

    const handleOpen1 = () => {
      setOpened1(true);
    };
  
    const handleClose1 = () => {
      setOpened1(false);
    };



    const handleOpenConfirm = () => {
      setOpenConfirm(true);
    };
  
    const handleCloseConfirm = () => {
      setOpenConfirm(false);
    };


    const handleConfirmYesClick = () => {
      sendidaustriaok();
      handleCloseConfirm();
    };
  
    const handleConfirmNoClick = () => {
      handleCloseConfirm();
    };

    const handleOpenRemoveConfirm = () => {
      setOpenRemoveConfirm(true);
    };
  
    const handleCloseRemoveConfirm = () => {
      setOpenRemoveConfirm(false);
    };


    const handleRemoveYesClick = () => {
      sendremoveidaustriaok();
      handleCloseRemoveConfirm();
    };
  
    const handleRemoveNoClick = () => {
      handleCloseRemoveConfirm();
    };

    
    const sendidaustriaok = () => {
      
      const handleidaustriaokpayload = {
        drnId: drnId,
        MeetingParticipantId: props.MeetingParticipantId,
        IsIdentified: true,
        IdentificationId: authId
      };
     dispatch({ type: 'SIGNALR_IDAUSTRIA_OK', payload: handleidaustriaokpayload });
  
    }

    const sendremoveidaustriaok = () => {
      const handleremoveidaustriaokpayload = {
        drnId: drnId,
        MeetingParticipantId: props.MeetingParticipantId,
        IsIdentified: false,
        IdentificationId: null
      };
      dispatch({ type: 'SIGNALR_IDAUSTRIA_OK', payload: handleremoveidaustriaokpayload });
    }
    



   // let auth_time ="2024-02-06T07:51:33+00:00"
   // let exp ="2024-02-06T08:51:34+00:00"

    let makedate = dayjs(auth_time).format('DD.MM.YYYY - HH:mm') 
    let expdate = dayjs(exp).format('DD.MM.YYYY - HH:mm') 



    let paperbackground
    if (isExpired){
      paperbackground = classes.bgred
    }


    
  return (
    <>
    <Paper shadow="sm" p="md" className={paperbackground}>
    {isExpired &&
    <Text fw={700} ta="center" c="red">Datensatz ist abgelaufen!</Text>
    }
    <Text fw={700}>{intl.get('IDA_DATA_HEAD')}:</Text>
    <Text fz="md"><Group><strong>{family_name} {given_name}</strong></Group></Text>
    <Text fz="md"><Group>{intl.get('IDA_DATA_BDATE')}: {birthdate }</Group></Text>
    <Text fz="md"><Group>{intl.get('IDA_DATA_ANSCHRIFT')}: <IDAustriashowAdress adress={urn_attributes_mainAddress} nation={urn_issuing_nation}/></Group></Text>
    <Text fz="md" fs="italic"><Group>{intl.get('IDA_DATA_MAKE')}: {makedate }</Group></Text>
    <Text fz="md" fs="italic"><Group>{intl.get('IDA_DATA_MAKETO')}: {expdate }</Group></Text>
   <Space h="md" />
   <Grid>
        <Grid.Col span={6}>
            {portrait !== null &&
            <Image src={`data:image/jpeg;base64,${portrait}`}  onClick={handleOpen}/>
            }
            {portrait === null &&
            <Alert  icon={<AlertTriangle size="1rem" />}  color="red" >
            <span>{intl.get('IDA_DATA_ERROR_NOPERPIC')}</span>
           </Alert>
            }
       </Grid.Col>
       <Grid.Col span={6}>
       {signature_usual_mark !== null &&
          <Image src={`data:image/jpeg;base64,${signature_usual_mark}`}  onClick={handleOpen1}/>
       }
       {signature_usual_mark === null &&
        <Alert  icon={<AlertTriangle size="1rem" />}  color="red" >
        <span>{intl.get('IDA_DATA_ERROR_NOUTPIC')}</span>
       </Alert>
      }
        </Grid.Col>
    </Grid>
    <Group position="right" mt="md" mb="xs">
       {showconfirmbutton &&
        <Tooltip label= {intl.get('IDA_DATA_CONFIRM')} multiline={true}>
           <span>
            <UserCheck size={24} strokeWidth={1} color="green" onClick={() => handleOpenConfirm()} />
          </span>
        </Tooltip>
      }

      {!showconfirmbutton &&
        <Tooltip label= {intl.get('IDA_DATA_CONFIRM_REMOVE')} multiline={true}>
           <span>
            <UserCheck size={24} strokeWidth={1} color="red" onClick={() => handleOpenRemoveConfirm()} />
          </span>
        </Tooltip>
      } 

    </Group>
   </Paper>
 

<Modal
  title={modalpichead}
  opened={opened}
  onClose={handleClose}
  closeOnClickOutside={false}
  withCloseButton={false}
  size="xl"
  shadow="sm"
  centered
>
<Image src={`data:image/jpeg;base64,${portrait}`}  />
  <hr />
  <Button fullWidth color="grey" variant="light" onClick={handleClose}>{intl.get('IDA_MODAL_PIC_BUTTON')}</Button>  
</Modal>

<Modal
  title={intl.get('IDA_MODAL_SIGN_HEAD')}
  opened={opened1}
  onClose={handleClose1}
  closeOnClickOutside={false}
  withCloseButton={false}
  size="xl"
  shadow="sm"
  centered
>
<Image src={`data:image/jpeg;base64,${signature_usual_mark}`} />
  <hr />
  <Button fullWidth color="grey" variant="light" onClick={handleClose1}>{intl.get('IDA_MODAL_SIGN_BUTTON')}</Button>  
</Modal>

<Modal
        title=""
        opened={openconfirm}
        onClose={handleCloseConfirm}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('IDA_DATA_CONFIRM')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleConfirmYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={handleConfirmNoClick}>{intl.get('DIALOG_BUTTON_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 

  
      <Modal
        title=""
        opened={removeconfirm}
        onClose={handleCloseRemoveConfirm}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('IDA_DATA_CONFIRM_REMOVE')}</Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleRemoveYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={handleRemoveNoClick}>{intl.get('DIALOG_BUTTON_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 

</>

  );
}

export default IdentShowIDAustriaData;